






















import { Component, Vue } from "vue-property-decorator";
import { engineDescList } from "@/components/listData";
@Component({
  components: {},
})
export default class Home extends Vue {
  public list = engineDescList;
}
